import axios from "axios";
import config from "../config/config";
import { utils } from "../utils/utils";

const handleError = (err) => {
  if (err?.response?.status === 401) {
    window.location.href = `/auth/sign-in?returnURL=${window.location.pathname}`;
  } else if (err?.response?.status === 404) {
    window.location.href = "/error/404";
  } else if (err?.response?.status === 400 || err?.response?.status === 422) {
    throw err;
  } else {
    window.location.href = "/error/500";
  }
};

export const activityApi = {
  getActivityLogs: (data) => {
    const query = utils.generateQueryString(data);
    return axios(`/api/logs?${query}`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "get",
      timeout: 60000, // wait for 60s
    })
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
};
